const phoneRegex = /^\+?[-\s0-9]*(\([-\s0-9]+\)[\d\s])?[-\s0-9]*([0-9 ]{1,})$/;

const isPhone = (value) => phoneRegex.test(value);

export default isPhone;
